import { render } from "./process-control-edit.vue?vue&type=template&id=764c894b&scoped=true&ts=true"
import script from "./process-control-edit.vue?vue&type=script&lang=ts"
export * from "./process-control-edit.vue?vue&type=script&lang=ts"

import "./process-control-edit.vue?vue&type=style&index=0&id=764c894b&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-764c894b"]])

export default __exports__